import { setCookie } from '../../mixins/cookie';
import { addQueryArgs } from '@wordpress/url';
import { getCompareCookie } from './toggle-compare';
import { messagePopup, displayMessagePopup } from '../../mixins/snackbar';
import { getWishListCookie } from '../wishlist/toggle-wishlist';
import { getUrl } from '../mixins/search';

const compareBoxNode = document.querySelector( '.wcbt-compare-box' );
const { __ } = wp.i18n;
let restUrl, restNamespace;

const wcbtCompareList = () => {
	if ( ! compareBoxNode ) {
		return;
	}

	restUrl = WCBT_GLOBAL_OBJECT.rest_url || '';
	restNamespace = WCBT_GLOBAL_OBJECT.rest_namespace || '';

	fetchProducts();
	removeProduct();
};

const fetchProducts = () => {
	compareBoxNode.style.opacity = 0.4;

	const productIds = getCompareCookie();
	const param = { post_in: productIds };

	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/compare', param ), method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content ) {
			compareBoxNode.innerHTML = res.data.content;
		}
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		compareBoxNode.style.opacity = 1;
	} );
};

const removeProduct = () => {
	document.addEventListener( 'click', function( event ) {
		const target = event.target;
		const removeNode = target.closest( '.remove' );
		if ( removeNode && compareBoxNode.contains( target ) ) {
			let productId = removeNode.getAttribute( 'data-product-id' );
			if ( productId ) {
				productId = parseInt( productId );
			}

			let productIds = getCompareCookie();
			if ( productIds.includes( productId ) ) {
				productIds = productIds.filter( ( item ) => item !== productId );
				setCookie( 'wcbt_compare_product', productIds.join( ',' ), 30 );
				fetchProducts();
				messagePopup.innerHTML = __( 'Product Compare removed', 'wcbt' );
				displayMessagePopup();
			}
		}
	} );
};

export default wcbtCompareList;
